import SERVER_URL from '@/config'

const feathers = require('@feathersjs/feathers')
const rest = require('@feathersjs/rest-client')
const auth = require('@feathersjs/authentication-client')

const app = feathers()

// Connect to a different URL
const restClient = rest(SERVER_URL)

// Configure an AJAX library (see below) with that client
app.configure(restClient.fetch(fetch))

app.configure(auth({
  storageKey: 'feathers-jwt'
}))

export default app
